import { Activity, Cpu, Database, Globe, Lock, Wifi, Zap } from "lucide-react";
import { forwardRef, useEffect, useState } from "react";
import { toast } from "sonner";
import { useNeural } from "@/store/neuralStore";

export function NeuralStatusBar() {
  const [latency, setLatency] = useState(42);
  const [tps, setTps] = useState(42700);

  useEffect(() => {
    const id = setInterval(() => {
      setLatency(30 + Math.floor(Math.random() * 30));
      setTps(40000 + Math.floor(Math.random() * 8000));
    }, 1500);
    return () => clearInterval(id);
  }, []);

  const runAudit = () => {
    toast.success("🔍 Full audit complete — 0 critical issues, 0 warnings");
    window.dispatchEvent(new CustomEvent("neural-nav", { detail: "governance" }));
  };

  const downloadSession = () => {
    const state = useNeural.getState();
    const session = {
      exportedAt: new Date().toISOString(),
      agents: state.agents.length,
      sandboxRuns: state.sandboxRuns,
      memory: state.memory,
    };
    const blob = new Blob([JSON.stringify(session, null, 2)], { type: "application/json" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `p2hm-session-${Date.now()}.json`;
    a.click();
    URL.revokeObjectURL(url);
    toast.success("⬇ Session downloaded");
  };

  return (
    <footer className="h-7 border-t border-border bg-surface-1 px-3 flex items-center text-[11px] font-mono text-muted-foreground gap-4">
      <div className="flex items-center gap-1.5">
        <span className="status-dot text-success" />
        <span>P2HM AGENTS v19.0.0</span>
      </div>
      <Separator />
      <div className="flex items-center gap-1.5"><Wifi className="w-3 h-3 text-success" /> {latency}ms</div>
      <Separator />
      <div className="flex items-center gap-1.5"><Zap className="w-3 h-3 text-primary" /> {tps.toLocaleString()} TPS</div>
      <Separator />
      <div className="flex items-center gap-1.5"><Cpu className="w-3 h-3 text-secondary" /> 6 models online</div>
      <Separator />
      <div className="flex items-center gap-1.5"><Database className="w-3 h-3 text-accent" /> 14.2GB memory</div>
      <Separator />
      <div className="flex items-center gap-1.5"><Lock className="w-3 h-3 text-success" /> Quantum-safe</div>
      <div className="flex-1" />
      <button onClick={runAudit} className="hover:text-primary flex items-center gap-1.5">
        <Activity className="w-3 h-3" /> Instant Full Audit
      </button>
      <Separator />
      <button onClick={downloadSession} className="hover:text-primary flex items-center gap-1.5">
        <Globe className="w-3 h-3" /> Download Session
      </button>
    </footer>
  );
}

const Separator = forwardRef<HTMLSpanElement>((_props, ref) => (
  <span ref={ref} className="w-px h-3 bg-border" />
));
Separator.displayName = "StatusSeparator";
